const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

// Parse date-only strings as local midnight; new Date(str) reads them as UTC and shows the previous day.
export const parseDate = (dateString) => {
  if (!dateString) return null;

  const dateOnly = DATE_ONLY_PATTERN.exec(dateString);
  const date = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(dateString);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (date) =>
  date?.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }) ?? null;
